import React, { useEffect, useState } from 'react'

import FileViewerButton from '../../@react-fefmwk/files/modules/FileViewerButton'
import FileViewer from '../../@react-fefmwk/files/modules/FileViewer'
import FileIcon from '../../@react-fefmwk/files/modules/FileIcon'
import TableOneRowTransposed from '../../@react-fefmwk/tables/modules/TableOneRowTransposed'

import { files_viewer } from '../../services/BE'

import { Box, Grid, Typography, Button } from '@material-ui/core'
import VisibilityIcon from '@material-ui/icons/Visibility'

const FilePreview = (props) => {
    const [profile, setProfile] = useState({})

    const basename = props.basename
    const filename = props.filename
    const extension = props.extension
    const relpath = props.relpath
    const lastchange = props.lastchange
    const mime_type = props?.mime_type || "default"

    const disable_trigger = !relpath
        ? true
        : (props.disabled === true ? true : false)

    const {
        dirname,
        relpath: _relpath,
        disabled: _disabled,
        ...filenfo
    } = props

    const fetchFile = async (path,filename) => {
        return await files_viewer(
            path,//relpath
            filename,//filename in download (label)
            false//force_download
        )
    }

    return <>
        <Grid container spacing={2} alignItems="center">
            <Grid item xs="auto">
                <FileIcon mime_type={mime_type} ext={extension} height={40} width={40} />
            </Grid>
            <Grid item xs>
                <Typography component="div" variant="body1">
                    {basename}
                </Typography>
                {lastchange
                    ? <Typography component="div" variant="caption">
                        {lastchange}
                    </Typography>
                    : null}
            </Grid>
            <Grid item xs="auto">
                <FileViewerButton
                    title={"Report "+filename}
                    mime_type={mime_type}
                    Trigger={<Button variant="outlined"
                        color="primary"
                        disabled={disable_trigger}
                        startIcon={<VisibilityIcon />}
                    >
                        anteprima
                    </Button>}
                    content={<Grid container spacing={2} style={{ height: "100%" }} >
                        <Grid item xs={12} md={9}>
                            <FileViewer output="viewer"
                                filename={filename}
                                mime_type={mime_type}
                                iframeToolbar={false}
                                printDownloadBtn={false}
                                fetchFile_f={() => fetchFile(
                                    relpath,
                                    filename
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <Box mb={2}>
                                <FileViewer output="button"
                                    filename={basename}
                                    save_as={filename}
                                    fetchFile_f={() => fetchFile(
                                        relpath,
                                        filename
                                    )}
                                />
                            </Box>
                            <Box mb={2}>
                                <TableOneRowTransposed
                                    material dense
                                    hideHeaders
                                    rowObject={filenfo}
                                />
                            </Box>
                        </Grid>
                    </Grid>}
                />
            </Grid>
        </Grid>
    </>
}

export default FilePreview